export default "__VITE_ASSET__af74ef13__"